<template lang="pug">
    v-autocomplete(dense 
        v-model="dataMonth" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        item-text="description" 
        item-value="id" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectMonth",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required"
    ],
    data() {
        return {
            dataMonth: {},
            listData: []
        }
    },
    mounted() {
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        }
    },
    created() {
        this.setMonth();
    },
    methods: {
        doInit(values){
            this.dataMonth = values ? values : null;
        },
        setMonth(){
            this.listData = [
                { id: "01", description: "Januari" },
                { id: "02", description: "Febuari" },
                { id: "03", description: "Maret" },
                { id: "04", description: "April" },
                { id: "05", description: "Mei" },
                { id: "06", description: "Juni" },
                { id: "07", description: "Juli" },
                { id: "08", description: "Agustus" },
                { id: "09", description: "September" },
                { id: "10", description: "Oktober" },
                { id: "11", description: "November" },
                { id: "12", description: "Desember" },
                
            ]
        },
        onSelect() {
            this.$emit("input", this.dataMonth);
            this.$emit("select", this.dataMonth);
            this.$emit("month", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataMonth === element.id) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>